import Base from 'app/models/base';

export default Base.extend({
  nameAndCompany() {
    const name = this.get('name');
    const company = this.get('company');
    let result = '';

    if (name && company) {
      result = `${company} c/o ${name}`;
    } else if (name) {
      result = name;
    } else if (company) {
      result = company;
    }

    return result;
  },

  cityStateZipCountry() {
    const cityState = [this.get('city'), this.get('state')].filter(s => s).join(', ');
    return [cityState, this.get('zip'), this.get('country')].filter(s => s).join(' ');
  },
});




// WEBPACK FOOTER //
// ./app/models/address.js